module.exports = __webpack_public_path__ + "54a590dfc95e82cb394c3cbd22a2dcfb.png";


//////////////////
// WEBPACK FOOTER
// ./shared/favicons/favicon-16x16.png
// module id = 1153
// module chunks = 2